(function () {
  var config = window.hauberRequest || {};
  var routes = window.routes || {};
  var debounceTimer = null;

  function t(key) {
    return config.translations && config.translations[key] ? config.translations[key] : key;
  }

  function parseJsonScript(script) {
    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function closestFormContainer(node) {
    return node.closest('[data-hauber-product-card], [data-template], .shopify-section, .drawer, aside, main') || document;
  }

  function findRequestForm(source, context) {
    var selector = '[data-hauber-request-form][data-source="' + source + '"]';
    var form = context ? context.querySelector(selector) : null;

    return form || document.querySelector('[data-hauber-request-drawer] ' + selector) || document.querySelector(selector);
  }

  function openPopup(form) {
    var popup = form ? form.closest('.m6pn') : null;

    if (!popup) {
      return;
    }

    var opener = document.querySelector('[data-hauber-request-popup-open][data-popup="' + popup.id + '"]');
    if (opener && opener.classList.contains('listening')) {
      opener.click();
      return;
    }

    if (typeof window.openPanel === 'function' && popup.id) {
      window.openPanel(popup.id);
      return;
    }

    document.documentElement.classList.add('has-panels', 'm6pn-open');
    popup.classList.add('toggle');
    popup.setAttribute('aria-hidden', 'false');
    popup.style.visibility = 'visible';
    popup.style.opacity = '1';
    popup.style.transform = 'none';
  }

  function showStatus(form, message, type) {
    var status = form.querySelector('[data-request-status]');

    if (!status) {
      return;
    }

    status.textContent = message || '';
    status.classList.toggle('is-hidden', !message);
    status.classList.toggle('is-success', type === 'success');
    status.classList.toggle('is-error', type === 'error');
  }

  function markFieldError(field, message) {
    var wrapper = field.closest('p, .check');

    if (wrapper) {
      wrapper.classList.add('hauber-request-field-error');

      if (message) {
        var errorMessage = wrapper.querySelector('[data-request-field-error]');

        if (!errorMessage) {
          errorMessage = document.createElement('span');
          errorMessage.className = 'hauber-request-field-error__message';
          errorMessage.setAttribute('data-request-field-error', '');
          wrapper.appendChild(errorMessage);
        }

        errorMessage.textContent = message;
      }
    }
  }

  function showErrors(form, errors) {
    var box = form.querySelector('[data-request-errors]');

    clearFieldErrors(form);

    if (errors) {
      Object.keys(errors).forEach(function (key) {
        var fieldErrors = Array.isArray(errors[key]) ? errors[key] : [errors[key]];
        var field = form.querySelector('[data-field="' + key + '"]');
        if (field) {
          markFieldError(field, fieldErrors[0]);
        }
      });
    }

    if (!box) {
      return;
    }

    box.innerHTML = '';
    box.classList.add('is-hidden');
  }

  function clearFieldErrors(form) {
    form.querySelectorAll('.hauber-request-field-error').forEach(function (node) {
      node.classList.remove('hauber-request-field-error');
    });

    form.querySelectorAll('[data-request-field-error]').forEach(function (node) {
      node.remove();
    });

    var box = form.querySelector('[data-request-errors]');
    if (box) {
      box.innerHTML = '';
      box.classList.add('is-hidden');
    }
  }

  function scrollToFirstFieldError(form) {
    var error = form.querySelector('.hauber-request-field-error');
    var panel = form.closest('.m6pn');
    var popupInner = form.closest('.hauber-request-popup--inner');
    var offset = panel ? 24 : 80;
    var top;

    if (!error) {
      return;
    }

    if (popupInner) {
      top = popupInner.scrollTop + error.getBoundingClientRect().top - popupInner.getBoundingClientRect().top - offset;

      if (typeof panel.scrollTo === 'function') {
        popupInner.scrollTo({
          top: top,
          behavior: 'smooth'
        });
      } else {
        popupInner.scrollTop = top;
      }

      return;
    }

    top = window.scrollY + error.getBoundingClientRect().top - offset;

    if (typeof window.scrollTo === 'function') {
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    }
  }

  function scrollToStatus(form) {
    var status = form.querySelector('[data-request-status]');
    var panel = form.closest('.m6pn');
    var popupInner = form.closest('.hauber-request-popup--inner');
    var offset = panel ? 24 : 80;
    var top;

    if (!status || status.classList.contains('is-hidden')) {
      return;
    }

    if (popupInner) {
      top = popupInner.scrollTop + status.getBoundingClientRect().top - popupInner.getBoundingClientRect().top - offset;

      if (typeof popupInner.scrollTo === 'function') {
        popupInner.scrollTo({
          top: top,
          behavior: 'smooth'
        });
      } else {
        popupInner.scrollTop = top;
      }

      return;
    }

    top = window.scrollY + status.getBoundingClientRect().top - offset;

    if (typeof window.scrollTo === 'function') {
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    }
  }

  function scheduleScrollToFirstFieldError(form) {
    requestAnimationFrame(function () {
      setTimeout(function () {
        scrollToFirstFieldError(form);
      }, 0);
    });
  }

  function scheduleScrollToStatus(form) {
    requestAnimationFrame(function () {
      setTimeout(function () {
        scrollToStatus(form);
      }, 0);
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function setNested(target, path, value) {
    var parts = path.split('.');
    var cursor = target;

    for (var i = 0; i < parts.length - 1; i += 1) {
      cursor[parts[i]] = cursor[parts[i]] || {};
      cursor = cursor[parts[i]];
    }

    cursor[parts[parts.length - 1]] = value;
  }

  function readFieldValue(field) {
    if (field.type === 'checkbox') {
      return field.checked;
    }

    return field.value ? field.value.trim() : '';
  }

  function prefillCustomer(form) {
    var customer = config.customer || {};

    [
      ['customer.salutation', customer.salutation],
      ['customer.title', customer.title],
      ['customer.first_name', customer.first_name],
      ['customer.last_name', customer.last_name],
      ['customer.email', customer.email],
      ['customer.phone', customer.phone],
      ['customer.company', customer.company],
      ['customer.department', customer.department],
      ['customer.customer_number', customer.customer_number],
      ['customer.vat_number', customer.vat_number],
      ['customer.billing_email', customer.billing_email],
      ['customer.billing_address', customer.billing_address],
      ['customer.billing_address_extra', customer.billing_address_extra],
      ['customer.billing_postcode', customer.billing_postcode],
      ['customer.billing_city', customer.billing_city],
      ['customer.billing_province', customer.billing_province],
      ['customer.billing_country', customer.billing_country],
      ['customer.delivery_address', customer.delivery_address],
      ['customer.delivery_address_extra', customer.delivery_address_extra],
      ['customer.delivery_postcode', customer.delivery_postcode],
      ['customer.delivery_city', customer.delivery_city],
      ['customer.delivery_province', customer.delivery_province],
      ['customer.delivery_country', customer.delivery_country],
      // ['customer.preferred_contact_method', customer.preferred_contact_method],
      ['customer.note', customer.note]
    ].forEach(function (pair) {
      var field = form.querySelector('[data-field="' + pair[0] + '"]');
      if (field && !field.value && pair[1]) {
        field.value = pair[1];
      }
    });

    var privacy = form.querySelector('[data-field="customer.privacy_policy"]');
    if (privacy && customer.privacy_policy === true) {
      privacy.checked = true;
    }
  }

  function deliveryFieldElements(form) {
    return Array.prototype.slice.call(form.querySelectorAll('[data-hauber-delivery-field]'));
  }

  function deliveryInputElements(form) {
    return Array.prototype.slice.call(form.querySelectorAll('[data-hauber-delivery-field] [data-field^="customer.delivery_"]'));
  }

  function hasDeliveryFieldValue(form) {
    return deliveryInputElements(form).some(function (field) {
      return Boolean(readFieldValue(field));
    });
  }

  function resetDeliveryFieldErrors(form) {
    deliveryInputElements(form).forEach(function (field) {
      var wrapper = field.closest('p, .check');
      if (!wrapper) {
        return;
      }

      wrapper.classList.remove('hauber-request-field-error');
      wrapper.querySelectorAll('[data-request-field-error]').forEach(function (node) {
        node.remove();
      });
    });
  }

  function setDeliveryFieldsVisible(form, visible, clearValues) {
    deliveryFieldElements(form).forEach(function (node) {
      node.classList.toggle('is-hidden', !visible);
    });

    if (visible || clearValues === false) {
      return;
    }

    deliveryInputElements(form).forEach(function (field) {
      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = false;
      } else {
        field.value = '';
      }
    });

    resetDeliveryFieldErrors(form);
  }

  function syncDeliveryAddressToggle(form, shouldClearWhenHidden) {
    var toggle = form.querySelector('[data-hauber-delivery-toggle]');
    if (!toggle) {
      return;
    }

    var visible = toggle.checked || hasDeliveryFieldValue(form);
    toggle.checked = visible;
    setDeliveryFieldsVisible(form, visible, shouldClearWhenHidden !== false);
  }

  function bindDeliveryAddressToggle(form) {
    var toggle = form.querySelector('[data-hauber-delivery-toggle]');
    if (!toggle || toggle.__hauberBound) {
      return;
    }

    toggle.__hauberBound = true;
    syncDeliveryAddressToggle(form, false);

    toggle.addEventListener('change', function () {
      setDeliveryFieldsVisible(form, toggle.checked, true);
    });
  }

  function formatMoney(value, currency) {
    var number = Number(value || 0);

    if (Number.isInteger(number)) {
      number = number / 100;
    }

    try {
      return new Intl.NumberFormat(config.locale || 'de', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(number);
    } catch (error) {
      return number.toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function renderRequestItems(form, items) {
    var box = form.querySelector('[data-request-items]');
    var nextHtml = '';

    if (!box) {
      return;
    }

    if (items && items.length) {
      nextHtml = '<h4>' + escapeHtml(t('items_heading')) + '</h4><ul class="l4ca compact">' + items.map(function (item) {
        var image = item.image_url
          ? '<header><figure><picture class="orientation"><img src="' + escapeHtml(item.image_url) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy"></picture></figure></header>'
          : '';
        var title = item.product_title || '';
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="small margin-half">' + escapeHtml(item.variant_title) + '</p>'
          : '';
        var sku = item.sku ? '<p class="small margin-half">' + escapeHtml(t('sku')) + ': ' + escapeHtml(item.sku) + '</p>' : '';
        var quantity = '<p class="small margin-half">' + escapeHtml(t('quantity')) + ': ' + escapeHtml(item.requested_quantity || item.quantity || 1) + '</p>';
        var price = item.price !== null && item.price !== undefined
          ? '<p class="s1pr"><span>' + escapeHtml(formatMoney(item.price, item.currency)) + '</span></p>'
          : '';

        return '<li>' +
          image +
          '<section><header><h2>' + escapeHtml(title) + '</h2>' + variant + sku + quantity + '</header></section>' +
          '<footer>' + price + '</footer>' +
          '</li>';
      }).join('') + '</ul>';
    }

    if (box.innerHTML !== nextHtml) {
      box.innerHTML = nextHtml;
    }

    box.hidden = !items || !items.length;
  }

  function collectFormPayload(form) {
    var payload = {
      locale: config.locale || 'de',
      source: form.getAttribute('data-source') || 'product',
      shop: config.shop || {},
      customer: Object.assign({}, config.customer || {}),
      spam: {}
    };
    var errors = {};

    clearFieldErrors(form);

    form.querySelectorAll('[data-field]').forEach(function (field) {
      var key = field.getAttribute('data-field');
      var value = readFieldValue(field);

      if (field.required && !value) {
        errors[key] = [t('required_error')];
        markFieldError(field, errors[key][0]);
      } else if (field.type === 'email' && value && field.validity && !field.validity.valid) {
        errors[key] = [t('email_error')];
        markFieldError(field, errors[key][0]);
      }

      setNested(payload, key, value);
    });

    if (config.customer && config.customer.customer_id) {
      payload.customer.customer_id = String(config.customer.customer_id);
    }

    return {
      payload: payload,
      errors: errors
    };
  }

  function openRequestForm(form, payloadBuilder, shouldScroll, resetState) {
    if (!form) {
      return;
    }

    var popupInner = form.closest('.hauber-request-popup--inner');
    if (popupInner) {
      popupInner.scrollTop = 0;
    }

    var startedAt = form.querySelector('[data-field="spam.started_at"]');
    form.__hauberPayloadBuilder = payloadBuilder;
    form.__hauberManualOpen = shouldScroll !== false;
    form.classList.remove('is-hidden');
    openPopup(form);
    prefillCustomer(form);
    syncDeliveryAddressToggle(form, false);
    renderRequestItems(form, payloadBuilder ? (payloadBuilder().items || []) : []);

    if (resetState !== false) {
      showErrors(form, null);
      showStatus(form, '', null);
    }

    if (startedAt) {
      startedAt.value = Math.floor(Date.now() / 1000);
    }

    if (shouldScroll !== false) {
      form.scrollIntoView({behavior: 'smooth', block: 'nearest'});
    }
  }

  function submitRequest(form) {
    var button = form.querySelector('[data-hauber-request-submit]');
    var collected = collectFormPayload(form);
    var builder = form.__hauberPayloadBuilder;
    var requestData = builder ? builder() : {};
    var payload = Object.assign({}, collected.payload, requestData);

    payload.customer = collected.payload.customer;
    payload.spam = collected.payload.spam;
    payload.locale = collected.payload.locale;
    payload.shop = collected.payload.shop;

    if (!config.endpoint) {
      showStatus(form, t('config_error'), 'error');
      return;
    }

    if (Object.keys(collected.errors).length > 0) {
      showErrors(form, collected.errors);
      showStatus(form, '', null);
      scheduleScrollToFirstFieldError(form);
      return;
    }

    if (!payload.items || payload.items.length === 0) {
      showStatus(form, t('generic_error'), 'error');
      return;
    }

    if (button) {
      button.disabled = true;
      button.textContent = t('sending');
    }

    function doFetch() {
      fetch(config.endpoint, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().catch(function () {
            return {success: false, message: t('generic_error')};
          }).then(function (json) {
            json.__status = response.status;
            return json;
          });
        })
        .then(function (json) {
          if (json.success) {
            showStatus(form, json.message || t('success'), 'success');
            showErrors(form, null);
            scheduleScrollToStatus(form);
            if ((payload.source || form.getAttribute('data-source')) === 'cart') {
              fetch(routes.cart_clear_url || '/cart/clear.js', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json'
                }
              }).catch(function () {
              });
            }
          } else {
            showErrors(form, json.errors || null);
            showStatus(form, json.errors ? '' : (json.message || t('generic_error')), json.errors ? null : 'error');
            if (json.errors) {
              scheduleScrollToFirstFieldError(form);
            }
          }
        })
        .catch(function (e) {
          showStatus(form, t('generic_error'), 'error');
          let popupInner = form.closest('.hauber-request-popup--inner');
          if (typeof popupInner.scrollTo === 'function') {
            popupInner.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          } else {
            popupInner.scrollTop = 0;
          }
        })
        .finally(function () {
          if (button) {
            button.disabled = false;
            button.textContent = t('submit');
          }
        });
    }

    var siteKey = config.recaptchaSiteKey;
    if (siteKey && typeof grecaptcha !== 'undefined' && typeof grecaptcha.execute === 'function') {
      grecaptcha.ready(function () {
        grecaptcha.execute(siteKey, {action: 'product_request'}).then(function (token) {
          payload.spam.recaptcha_token = token;
          doFetch();
        }).catch(function () {
          doFetch();
        });
      });
    } else {
      doFetch();
    }
  }

  function bindForms(root) {
    root.querySelectorAll('[data-hauber-request-form]').forEach(function (form) {
      if (form.__hauberBound) {
        return;
      }

      form.__hauberBound = true;
      var button = form.querySelector('[data-hauber-request-submit]');
      if (button) {
        button.addEventListener('click', function () {
          submitRequest(form);
        });
      }

      bindDeliveryAddressToggle(form);
    });
  }

  function productData(trigger) {
    var context = trigger ? closestFormContainer(trigger) : document;

    return parseJsonScript(context.querySelector('[data-hauber-product-request-data]')) ||
      parseJsonScript(document.querySelector('[data-hauber-product-request-data]'));
  }

  function selectedVariantId(trigger) {
    var form = trigger.closest('form');
    var field = form ? form.querySelector('[name="id"]') : document.querySelector('[name="id"]');

    if (field && field.value) {
      return String(field.value);
    }

    var match = window.location.search.match(/[?&]variant=([^&]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function selectedQuantity(trigger) {
    var form = trigger.closest('form');
    var field = form ? form.querySelector('[name="quantity"]') : document.querySelector('[name="quantity"]');
    var quantity = field ? parseInt(field.value, 10) : 1;

    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function availabilityModeForItem(item) {
    if (!item || !item.availability_base_mode) {
      return null;
    }

    var quantity = Number(item.quantity || item.requested_quantity || 1);
    var inventoryQuantity = Number(item.inventory_quantity);
    var usesExcessMode = item.inventory_management === 'shopify'
      && inventoryQuantity > 0
      && quantity > inventoryQuantity;

    return usesExcessMode && item.availability_excess_mode
      ? item.availability_excess_mode
      : item.availability_base_mode;
  }

  function reasonForItem(item) {
    var availabilityMode = availabilityModeForItem(item);

    if (availabilityMode === 'cart') {
      return null;
    }

    if (!item || item.inventory_management !== 'shopify') {
      return 'unknown_stock';
    }

    if (item.available === false || Number(item.inventory_quantity) <= 0) {
      return 'out_of_stock';
    }

    if (Number(item.quantity) > Number(item.inventory_quantity)
      && (availabilityMode || item.inventory_policy === 'deny')) {
      return 'quantity_exceeds_stock';
    }

    return null;
  }

  function productRequestPayload(trigger) {
    var data = productData(trigger);
    var variantId = selectedVariantId(trigger);
    var quantity = selectedQuantity(trigger);
    var variant = data && data.variants ? data.variants.filter(function (item) {
      return String(item.variant_id) === String(variantId);
    })[0] : null;

    if (!variant && data && data.variants && data.variants.length) {
      variant = data.variants[0];
    }

    if (!variant) {
      return {source: 'product', items: []};
    }

    var item = Object.assign({}, variant, {
      quantity: quantity,
      requested_quantity: quantity
    });
    item.request_reason = reasonForItem(item) || 'unknown_stock';

    return {
      source: 'product',
      items: [item]
    };
  }

  function bindTriggers(root) {
    root.querySelectorAll('[data-hauber-request-trigger]').forEach(function (trigger) {
      if (trigger.__hauberBound) {
        return;
      }

      trigger.__hauberBound = true;
      trigger.addEventListener('click', function (event) {
        var source = trigger.getAttribute('data-hauber-source') || 'product';
        var context = closestFormContainer(trigger);
        var form = findRequestForm(source, context);

        event.preventDefault();
        event.stopImmediatePropagation();

        if (source === 'product') {
          openRequestForm(form, function () {
            return productRequestPayload(trigger);
          });
        }
      }, true);
    });
  }

  function cloneItem(item) {
    return Object.assign({}, item);
  }

  function syncCartQuantities(data, script) {
    var container = script.parentElement || document;
    var inputs = container.querySelectorAll('input[name="updates[]"]');

    data.items.forEach(function (item, index) {
      var liveQuantity = inputs[index] ? parseInt(inputs[index].value, 10) : item.quantity;
      var quantity = Number.isFinite(liveQuantity) && liveQuantity > 0 ? liveQuantity : item.quantity;

      item.quantity = quantity;
      item.requested_quantity = quantity;
      item.request_reason = reasonForItem(item);
    });

    return data;
  }

  function problemItems(items) {
    return items.filter(function (item) {
      return Boolean(item.request_reason);
    }).map(cloneItem);
  }

  function createCartMessage() {
    var message = document.createElement('div');

    message.className = 'hauber-cart-request-message';
    message.setAttribute('data-hauber-cart-message', '');
    message.innerHTML = '<p>' + escapeHtml(t('cart_blocked')) + '</p>' +
      '<p class="link-btn wide margin-0"><button type="button" class="overlay-tertiary" data-hauber-cart-request-open>' +
      escapeHtml(t('cart_request_button')) +
      '</button></p>';

    return message;
  }

  function findCartMessage(container) {
    return container.querySelector('[data-hauber-cart-message]');
  }

  function checkoutButtons(container) {
    return container.querySelectorAll('form.form-cart > fieldset button[name="checkout"][type="submit"]');
  }

  function setCheckoutBlocked(container, blocked) {
    checkoutButtons(container).forEach(function (control) {
      if (blocked) {
        if (control.__hauberCheckoutHtml === undefined) {
          control.__hauberCheckoutHtml = control.innerHTML;
        }
        control.textContent = t('cart_request_button');
      } else if (control.__hauberCheckoutHtml !== undefined) {
        control.innerHTML = control.__hauberCheckoutHtml;
        delete control.__hauberCheckoutHtml;
      }

      control.hidden = false;
      control.disabled = false;
      control.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      control.classList.remove('hauber-request-disabled');
    });

    container.querySelectorAll('[data-hauber-checkout-control]').forEach(function (control) {
      control.hidden = blocked;
      control.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      control.classList.toggle('hauber-request-disabled', blocked);
    });
  }

  function bindBlockedCheckout(container, form, payloadBuilder) {
    checkoutButtons(container).forEach(function (control) {
      if (control.__hauberBlockedCheckoutBound) {
        control.__hauberPayloadBuilder = payloadBuilder;
        control.__hauberRequestForm = form;
        return;
      }

      control.__hauberBlockedCheckoutBound = true;
      control.__hauberPayloadBuilder = payloadBuilder;
      control.__hauberRequestForm = form;
      control.addEventListener('click', function (event) {
        if (control.getAttribute('aria-disabled') !== 'true') {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        openRequestForm(control.__hauberRequestForm, control.__hauberPayloadBuilder);
      }, true);
    });
  }

  function evaluateCartScript(script) {
    var data = parseJsonScript(script);
    var container = script.parentElement || document;
    var form = findRequestForm('cart', container);

    if (!data) {
      return;
    }

    data = syncCartQuantities(data, script);
    var unavailableItems = problemItems(data.items || []);
    var blocked = unavailableItems.length > 0;
    var message = findCartMessage(container);
    var allItems = (data.items || []).map(cloneItem);
    var payloadBuilder = function () {
      return {
        source: 'cart',
        items: allItems,
        cart: data.cart || {}
      };
    };

    setCheckoutBlocked(container, blocked);

    if (blocked) {
      message = message || createCartMessage();

      if (!message.parentElement) {
        // if (form) {
        //   form.parentNode.insertBefore(message, form);
        // } else {
        container.appendChild(message);
        // }
      }

      if (form) {
        form.__hauberPayloadBuilder = payloadBuilder;
        renderRequestItems(form, allItems);
        if (!form.__hauberManualOpen) {
          form.classList.add('is-hidden');
        }
      }

      var openButton = message.querySelector('[data-hauber-cart-request-open]');
      if (openButton && !openButton.__hauberBound) {
        openButton.__hauberBound = true;
        openButton.addEventListener('click', function () {
          openRequestForm(form, form ? form.__hauberPayloadBuilder : payloadBuilder);
        });
      }

      bindBlockedCheckout(container, form, form ? form.__hauberPayloadBuilder : payloadBuilder);
    } else {
      if (message && message.parentElement) {
        message.parentElement.removeChild(message);
      }

      if (form) {
        form.__hauberManualOpen = false;
        form.classList.add('is-hidden');
        renderRequestItems(form, []);
      }
    }

    if (!script.__hauberBound) {
      script.__hauberBound = true;
      container.addEventListener('input', function (event) {
        if (event.target && event.target.matches('input[name="updates[]"]')) {
          evaluateCartScript(script);
        }
      });
    }
  }

  function evaluateCarts(root) {
    root.querySelectorAll('[data-hauber-cart-request-data]').forEach(evaluateCartScript);
  }

  function orderData(block) {
    return parseJsonScript(block.querySelector('[data-hauber-order-request-data]'));
  }

  function normalizeReorderItems(items, mode) {
    return (items || []).map(function (item) {
      var copy = cloneItem(item);
      copy.request_reason = reasonForItem(copy);

      if (mode === 'all' && !copy.request_reason) {
        copy.request_reason = 'unknown_stock';
      }

      return copy;
    }).filter(function (item) {
      return mode === 'all' ? true : Boolean(item.request_reason);
    });
  }

  function bindReorders(root) {
    root.querySelectorAll('[data-hauber-reorder]').forEach(function (block) {
      if (block.__hauberBound) {
        return;
      }

      block.__hauberBound = true;
      var data = orderData(block) || {};
      var items = data.items || [];
      var unavailable = normalizeReorderItems(items, 'unavailable');
      var addButton = block.querySelector('[data-hauber-reorder-add]');
      var message = block.querySelector('[data-hauber-reorder-message]');
      var form = findRequestForm('reorder', block);

      if (message && unavailable.length > 0) {
        message.textContent = t('reorder_request_all_notice');
      }

      if (addButton) {
        addButton.addEventListener('click', function () {
          if (unavailable.length > 0) {
            openRequestForm(form, function () {
              return {
                source: 'reorder',
                items: normalizeReorderItems(items, 'all'),
                order: data.order || {}
              };
            });
            return;
          }

          addReorderItems(block, items);
        });
      }
    });
  }

  function addReorderItems(block, items) {
    var message = block.querySelector('[data-hauber-reorder-message]');
    var available = (items || []).filter(function (item) {
      return !reasonForItem(item) && item.variant_id;
    }).map(function (item) {
      var cartItem = {
        id: item.variant_id,
        quantity: item.quantity || 1
      };

      if (item.image_url) {
        cartItem.properties = {
          '_hauber_image_url': item.image_url
        };
      }

      return cartItem;
    });

    if (!available.length) {
      if (message) {
        message.textContent = t('reorder_none_available');
      }
      return;
    }

    fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({items: available})
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart add failed');
      }

      if (message) {
        message.textContent = t('reorder_added');
      }

      window.location.href = routes.cart_url || '/cart';
    }).catch(function () {
      if (message) {
        message.textContent = t('generic_error');
      }
    });
  }

  function init(root) {
    root = root || document;
    bindForms(root);
    bindTriggers(root);
    evaluateCarts(root);
    bindReorders(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        init(document);
      }, 120);
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
